/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
import React, {useCallback, useEffect} from 'react';
import {Box, NftGridList, NFTTrackCard} from '@ttx/design-system';
import {getOpenseaUrl} from '../../contexts/authentication-context/consts';
import {MAX_NFT_GRID_COLUMNS, MIN_NFT_GRID_COLUMNS} from '../../utils/consts';
import {NoNft} from '../no-nft/no-nft';
import {NftToken} from '../../server/router/collection/types';
import {BlockchainPropsWrapper} from '../blockchain-props-wrapper';

export const ArtistNFTPage = ({
  data,
  hasBorder = false,
  hideCurrency = false,
}: {
  data: NftToken[];
  hasBorder?: boolean;
  hideCurrency?: boolean;
}) => {
  const renderItem = useCallback((item: typeof data[number]) => {
    return (
      <BlockchainPropsWrapper
        multiCopy={item.multiCopy}
        network={item.network}
        type={item.type}
        nftToken={item}
      >
        <NFTTrackCard
          key={item._id}
          src={item.image || 'src'}
          artist=""
          trackName={item.name}
          isVideo={item.isVideo}
          openseaUrl={getOpenseaUrl(
            item.network,
            item.contractAddress,
            item.tokenId,
          )}
          hasBorder={hasBorder}
          hideCurrency={hideCurrency}
        />
      </BlockchainPropsWrapper>
    );
  }, []);

  const getAllNFTView = () => {
    if (data.length === 0) {
      return (
        <NoNft
          title="This artist doesn’t have any NFTs yet."
          subtitle="Find out more about their work here"
        />
      );
    }
    return (
      <NftGridList
        columns={data.length > 4 ? MAX_NFT_GRID_COLUMNS : MIN_NFT_GRID_COLUMNS}
        rowSpace="xxs"
        columnSpace="xxs"
        keyExtractor={(item: {_id: string}) => item._id}
        loading={false}
        items={data}
        error=""
        renderItem={renderItem}
      />
    );
  };

  return (
    <Box>
      <Box>{getAllNFTView()}</Box>
    </Box>
  );
};
